let state= {count:0}
// let state1=()
export default state